import React from 'react';
import { Create } from 'react-admin';

import UserForm from '../UserForm';

function UserCreate(props) {
  return (
    <Create {...props} title="Crear usuario">
      <UserForm isCreate />
    </Create>
  );
}

export default UserCreate;
